const helpInstructions = {
  'poll-data-photos': 
    'Será a imagem miniatura (200 x 200 px) que aparecerá no perfil do seu edital. O sistema só aceita as extensões de arquivos ".png" e ".jpg" e cujo nome do arquivo não contenha caracteres especiais (ex: `, ˜, /, \\, ç, \', <, > ?, !, #, $, %, *, @).',
  'poll-data-description':
    'Insira aqui as informações que ficarão disponíveis para que os usuários entendam quais são as regras e os objetivos da sua votação.',
  'poll-data-description':
    'Insira aqui as informações que ficarão disponíveis para que os usuários entendam quais são as regras e os objetivos da sua votação.',
  'poll-configuration-publishDate':
    'Programe uma data e horário para que a votação fique disponível. Caso esta data não seja preenchida, a votação entrará em vigor imediatamente após seu envio.'
};

const getFormInstruction = ( formField ) => { return helpInstructions[ formField ] }

export default getFormInstruction;


// WEBPACK FOOTER //
// ./src/const/form/formInstructionHelper.js